<template>
  <div class="container">
    <!--Section: Content-->
    <div class="mb-5 contactUs">
      <!-- Grid row -->
      <div class="row">
        <div class="col-12">
          <div class="card z-depth-2">
            <div class="card-body p-0">
              <div class="row mx-0 contactUs__first">
                <div class="col-lg-6 black rounded-left py-5 px-md-5 call-me">
                  <div>
                    <a href="tel:+33618277862" class="footer-icon">
                      <i class="fas fa-phone mx-2"></i>
                    </a>
                    <a href="sms:+33618277862" class="footer-icon">
                      <i class="fa fa-comments mx-2"> </i>
                    </a>
                    <a href="mailto:contact@youcanlearn.fr" class="footer-icon">
                      <i class="fa fa-envelope mx-2"> </i>
                    </a>
                  </div>
                </div>
                <div
                  class="contactUs__second col-lg-6 red accent-3 rounded-right py-5 px-md-5"
                >
                  <h3 class="jaapokki">you<span>can</span>learn</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Grid row -->
    </div>
    <!--Section: Content-->
  </div>
</template>

<script>
export default {
  name: "ContactUsAction",
};
</script>

<style lang="scss" scoped>
.contactUs {
  &:hover {
    & h3 {
      color: $color-text;
      & span {
        color: $color-secondary;
      }
    }
  }
  &__first {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $color-darker;
    & i {
      font-size: 50px;
      color: $color-primary;
      background: rgba($color: $color-secondary, $alpha: 0.3);
      margin: auto;
      padding: 9px;
      border-radius: 10px;
      @media screen and (min-width: 992px) {
        font-size: 50px;
      }
    }
    & .rounded-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      @media screen and (min-width: 992px) {
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      & img {
        background: $color-primary;
        border-radius: 50%;
        padding: 2px;
        @media screen and (max-width: 992px) {
          margin-top: 1.5rem;
        }
      }
    }
  }
  &__second {
    background: $color-lighter;
    display: flex;
    justify-content: center;
    &:hover {
      color: $color-primary;
      & h3 {
        color: $color-primary;
        & span {
          color: $color-darker;
        }
      }
    }
    & h3 {
      font-size: 3em;
      @media screen and (min-width: 992px) {
        font-size: 4em;
      }
      color: $color-darker;
      margin: auto;
      & span {
        color: $color-primary;
      }
      &:hover {
        color: $color-primary;
        & h3 {
          color: $color-primary;
          & span {
            color: $color-darker;
          }
        }
      }
    }
  }
}
</style>
